import auth from "../middlewares/auth";
export const pages = [
    {
        path: '/pages/:type',
        component: () => import(/* webpackChunkName: "pages" */ '../views/page/Index'),
        name: 'pages',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/pages/:type/sort',
        component: () => import(/* webpackChunkName: "pages" */ '../views/page/Sort'),
        name: 'pages_sort',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/pages/:type/add',
        component: () => import(/* webpackChunkName: "pages" */ '../views/page/Form'),
        name: 'pages_add',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/pages/:type/edit/:id',
        component: () => import(/* webpackChunkName: "pages" */ '../views/page/Form'),
        name: 'page_edit',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/pages/:type/view/:id',
        component: () => import(/* webpackChunkName: "pages" */ '../views/page/View'),
        name: 'page_view',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/custom-pages/:slug',
        component: () => import(/* webpackChunkName: "pages" */ '../views/page/CustomPage'),
        name: 'custom_page',
        meta: {
            middleware: [
                auth
            ]
        }
    },
];
